module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "35.99%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("Y")]), _vm._v("ou know when you want something SOOO much and you’re 99.9 percent sure you’re going to get it? But there’s a teensy chance you won’t? (Only a very teensy chance.) And you can’t eat or sleep or do anything but think about how excited you’re going to be when you DO get it?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s how I feel about getting picked to be student leader of our school carnival. Any second now, the principal is going to name the leader.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And it’s going to be ME!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From my seat in the auditorium, I watch as Principal Braun walks onto the stage. She taps the microphone. “Testing, one two,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ahhh! I can’t take the suspense.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And now,” Ms. Braun continues, “I will announce who we have chosen to be the student leader of the carnival.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sit up super straight in my chair. My best friend Frankie is sitting on my left side. Our other best friend, Robin, is on my right. The entire elementary school is here. Everyone is excited for the big announcement, but NO ONE is more excited than I am.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What does the student leader of the carnival do? So much! Like work with the teachers to plan all the activities, and help decide on fun games, yummy food, and awesome prizes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I am very good at making decisions. For example, this morning, when my dad asked if I wanted pancakes or eggs, I immediately said pancakes — with blueberries. And yesterday, when my mom asked me which shoes went better with the black suit she was wearing for her big case — Mom’s a lawyer, like Dad — I pointed to the red ones. Did my mom win her case with her red shoes? She totally did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Did I mention I’m going to be a judge when I grow up? Because that’s what judges do. Make decisions. Well, first I’m going to be a lawyer like my parents are, and then I’m going to be a judge because that’s the way you have to do it. You also have to use a gavel. Okay, you probably don’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("have")]), _vm._v(" to use a gavel, but why would you not? Gavels are amazing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ms. Braun is fiddling with the microphone. She raises it slightly. This is it. The moment I’ve been waiting for. Earlier today, Ms. Braun and the teachers in charge of the carnival all got together to pick the student leader from the list of kids who applied.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why am I so sure my name will be called?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("First of all, to be the student leader, you have to be a fifth grader, the oldest grade in the school. And I am a fifth grader!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know what you’re thinking: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Big deal, Abby. There are A LOT of other fifth graders")]), _vm._v(". And you’re right. But when the sign-up sheet was posted, I was the first person to put my name down. That shows just how much I want this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Also, to apply for the position, you had to hand in five ideas for the carnival. And guess what? I came up with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ten. ")]), _vm._v("Including a dunk tank, a booth where you can decorate your own cookies, and a booth where you can squeeze your own lemonade. Doesn’t everyone want to squeeze their own lemonade? Yes. Of course! Everyone does!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The school carnival is supposedly the best part of Smithville Elementary. I missed last year’s, since I didn’t live in Smithville then, but everyone says it’s incredible. It takes place over an entire Friday. And I’m going to lead it!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s definitely going to be you, Abby,” Frankie whispers to me as she pushes her red glasses up on her nose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I give her a grateful smile and shift in my seat nervously. To be on the safe side, I wore my lucky underwear today. Okay, fine, I don’t really have lucky underwear, but these have green polka dots on them and green is a lucky color, so maybe they’ll work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Definitely,” Robin adds with such a serious nod that her reddish curls bounce on her shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or it will be someone else,” Penny says from the other side of Robin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Penny is Robin’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("other")]), _vm._v(" best friend. I glance over at her. She’s examining her nails and looks totally bored.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wow, THANKS, Penny. After everything we went through in Wonderland together? Where is the loyalty?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ms. Braun clears her throat. “This year’s leader of the school carnival is …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I can’t stop smiling! Should I stand up and wave to the crowd when my name is called? Yes, that seems like the right thing to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anisa Najeed!” Ms. Braun announces.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes! I stand up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Congrats, Anisa!” Ms. Braun adds.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wait, what?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What did she just say?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Penny snort-laughs. “Sit down, Abby. She said Anisa Najeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The smile freezes on my face. My heart clenches. My stomach twists. I might cry. I need to sit. Yes, the first thing I need to do is sit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sit back down on the hard seat. Frankie puts her arm around me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I can’t believe it. I really thought I was going to get it. Did they actually pick Anisa? How is that possible?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There are loud noises all around me. Everyone is … clapping. Clapping?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh. They are clapping for Anisa.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Should I clap, too? Yes. I probably should. But I can’t seem to do it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rats,” Frankie whispers. “I’m sorry, Abby. I know how badly you wanted to win.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Robin makes a sad face. “You can have the brownie my mom packed me for dessert at lunch,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, guys,” I barely manage to croak out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I try to look like I’m not upset. But how do you make your eyes un-teary, your face un-splotchy, and your expression un-miserable when you’re ready to sob like a toddler who just dropped her ice cream cone on the floor?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How could the teachers choose Anisa instead of me? She barely talks. Yesterday, she was sitting at our lunch table and I didn’t even realize she was there. Because she didn’t say one word the whole time! How can someone be a leader if she’s as quiet as a pet turtle? It’s going to be a horrible carnival.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We’re dismissed from the auditorium and I walk out into the hallway with Robin, Frankie, and Penny. Everyone is swarming around Anisa, congratulating her. I feel myself starting to get mad. This is totally unfair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uh-oh. Oh, no. Anisa is looking at me. She’s tilting her head. She’s biting her lower lip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’s walking toward me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Crumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, Abby,” Anisa says to me. She is pretty, with long black hair, brown skin, and dark brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know I’m supposed to congratulate her. But all that comes out of my mouth is “Hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’s not saying anything else, either. Because she’s TOO QUIET.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We stare at each other. AWK-WARD.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Um, Abby?” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah?” I ask. I cross my arms in front of my chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will you help me with the carnival?” Anisa asks. “I know you have some great ideas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I can feel my cheeks burning. My face must be bright red.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wants "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me ")]), _vm._v("to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her ")]), _vm._v("second-in-command? No way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uh, sorry,” I mumble. “I’m, um, really busy. Super busy. I have a lot of homework and I have a dog and a brother and they both need me to, um … spend time with them. And stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anisa gives me a confused smile. Luckily, a bunch of other kids surround her to congratulate her, and I slip away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So annoying,” I whisper to Frankie and Robin, rejoining them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too bad, so sad,” Penny says, flipping her blond hair behind her shoulder. “But honestly, Abby, who cares?” She leans close to me and whispers, “You have much cooler things in your life than an elementary school carnival.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shhhhh,” I whisper back. Am I going to have to spend my entire life worrying that Penny is going to give away my secret?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I think I am.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Here’s what Penny is referring to: I have a magic mirror in the basement of my house. I really do. My little brother, Jonah, and I discovered it when we moved to Smithville. If you knock on the mirror three times at midnight, a magic fairy turns the mirror into a portal that takes you into different fairy tales. It sounds like I’m joking, but I’m not. I’ve visited fairy tales like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Frog Prince")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cinderella")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hansel and Gretel")]), _vm._v(". And yeah. The witch in that one totally tried to eat us. But snacking on her candy house made it almost worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Usually, just my brother and I (and our dog, Prince) go into the fairy tales. Robin came into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sleeping Beauty")]), _vm._v(" with me, but she pricked her finger and fell asleep and doesn’t remember. But a couple of weeks ago, Penny, Frankie, Robin, and I went through a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("different")]), _vm._v(" portal (in a golf course) and ended up going into Wonderland. As in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alice’s Adventures in Wonderland")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Frankie and Robin don’t remember being in Wonderland because they were sprinkled with magic powder. But Penny wasn’t sprinkled with much of it, so she remembers everything. Part of me hates that Penny knows I go into stories — her of all people! But part of me kind of likes that at least somebody, even Penny, knows my secret.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’s asked me if she can sleep over five times in the last two weeks. She desperately wants to go to fairy tale land.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, even having this cool magical secret can’t cheer me up today. Ahead of us in the hallway, more kids are crowding around the new carnival leader.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yay, Anisa!” a fourth-grade girl cheers. “Can’t wait for the carnival! You’re going to have a cotton candy machine, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yup,” Anisa says. “Blue and pink.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I scowl. Blue and pink? Seriously? She should obviously have the cotton candy in our school colors. Blue and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yellow. ")]), _vm._v("But I’m not going to suggest that. Nope. I am done giving away my carnival ideas. They don’t want me to be in charge? Then they don’t get my ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Too bad, so sad.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48965aec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781338162905_ch001.vue
// module id = 66
// module chunks = 0